import Box from "@mui/material/Box";
import useScrollDirection from "hooks/useScrollDirection";
import React from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "redux/hooks";
import { useSetDisplayHeaderSearch, useSetInputValue } from "redux/searchText/searchText";
import { useMedia } from "react-use";
import Footer from "./Footer";
import Header from "./Header";
import styles from "./styles.module.scss";

type MainLayoutProps = {
  children: React.ReactNode;
};

function MainLayout(props: MainLayoutProps) {
  const { children } = props;
  const dispatch = useAppDispatch();

  const location = useLocation();

  const isLargeScreen = useMedia('(min-width: 768px)');

  const isDashboard = location.pathname.includes("dashboard");

  const isSubcategory = location.pathname.includes("sub-categories");

  const {onChangeInputValue} = useSetInputValue();

  const yOffSet = React.useMemo(()=>{
    if(isDashboard) return 90
    if(isLargeScreen) return 20
    if(isSubcategory) return 120
    return 160
  },[isDashboard,isLargeScreen,isSubcategory])
  // const isDisplaySearchTop = React.useMemo(()=>{
  //   console.log('window.pageYOffset', window.scrollY)
  //   if(scrollDirection==='up'&& window.scrollY < 30){
  //     return true
  //   }
  //   return false
  // },[scrollDirection,window.scrollY])

  // console.log(isDisplaySearchTop);
  // React.useEffect(() => {
  //   const searchBox = document.getElementById(
  //     "app-search-header"
  //   ) as HTMLElement;
  //   const containerSearchBox = document.getElementById(
  //     "search-box-container-header"
  //   ) as HTMLElement;
  //   const containerSearchBoxDescription = document.getElementById(
  //     "search-box-container-description"
  //   ) as HTMLElement;
  //   const querySearchBoxs = document.querySelectorAll("#app-search-header");
  //   if (location && searchBox) {
  //     if (
  //       containerSearchBox &&
  //       containerSearchBox.querySelector("#app-search-header")
  //     ) {
  //       containerSearchBox.removeChild(searchBox);
  //     } else if (
  //       containerSearchBoxDescription &&
  //       querySearchBoxs &&
  //       querySearchBoxs.length > 1
  //     ) {
  //       containerSearchBoxDescription.removeChild(searchBox);
  //     }
  //   }
  // }, [location]);

  const { onChangeDisplayHeader } = useSetDisplayHeaderSearch();
  React.useEffect(() => {
    const handleScroll = (event: any) => {
      onChangeDisplayHeader(
        window.scrollY > yOffSet
      );
    };
    onChangeInputValue('');
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname,yOffSet]);

  return (
    <>
      <Header />
      {/* <LeftMenu /> */}
      <Box component="main" className={styles.main}>
        <Box className={styles.paper}>{children}</Box>
      </Box>
      <Footer />
    </>
  );
}

export default MainLayout;
function setDisplayHeaderSearch(arg0: {
  isDisplayHeaderSearch: string | boolean;
}): any {
  throw new Error("Function not implemented.");
}
